
<div class="add-or-edit-container">
  <div class="title-container">
    <h3>Incluir CNPJ</h3>
  </div>

  <form [formGroup]="formGroup">

    <div style="padding: 0 100px;" fxLayout="row" fxLayoutAlign="center stretch" fxLayoutGap="20px">
      <div fxFlex="50">
        <fd-institution (institutionSelected)="changeSelectedInstitution($event)" [formGroup]="formGroup"
          [field]="fields.institution">
        </fd-institution>
      </div>
      <div fxFlex="50">
        <fd-service-contract [formGroup]="formGroup" [field]="fields.serviceContract"
          [institution]="selectedInstitution" [lockControl]="editionModal">
        </fd-service-contract>
      </div>
    </div>


    <div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="20px">
      <div fxFlex="30">
        <fd-input [parentForm]="formGroup" [field]="cnpjField"></fd-input>
      </div>
      <div fxFlex="70">
        <fd-input [parentForm]="formGroup" [field]="clientNameField"></fd-input>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="20px">
      <div fxFlex="30">
        <fd-input [parentForm]="formGroup" [field]="cnaeField" (input)="sanitizeCnae($event)" (pasteHandler)="sanitizeCnae($event)"></fd-input>
      </div>
      <div fxFlex="70" fxLayout="row" fxLayoutGap="20px">
        <div fxFlex="50">
          <fd-datepicker [parentForm]="formGroup" [field]="startDateField"></fd-datepicker>
        </div>
        <div fxFlex="50">
          <fd-datepicker [parentForm]="formGroup" [field]="endDateField"></fd-datepicker>
        </div>
      </div>
    </div>
  </form>

  <div mat-dialog-actions align="center">
      <div class="value-edit-table__button-container">
        <fd-button mat-button fdSecondaryLarge [content]="'Cancelar'" (trigger)="close()"></fd-button>
        <fd-button fdPrimaryLarge mat-flat-button [content]="'Salvar'" (trigger)="editionModal ? update() : save()">
        </fd-button>
      </div>
    </div>
</div>
